<h2 class="form-title">
    {{ 'fe_hbspt_form_title_1' | translate }}
    <span class="highlight-text">
        {{ 'fe_hbspt_form_title_2' | translate }}</span
    >
</h2>
<p class="form-subtitle">
    {{ 'fe_hbspt_form_subtitle' | translate }}
</p>
<div id="hubspotFormEnNew"></div>
